import request from './request'

export function fetchDanmuData () {
  return request({
    method: 'get',
    url: `/v1/danmu/list`
  })
}
